module.exports = __webpack_public_path__ + "img/button_nothing.1afdf181.png";